import React from 'react';
import { Droppable } from 'react-beautiful-dnd';
import PropTypes from 'prop-types';

const DroppableRegion = (props) => {
    return (
        <Droppable droppableId={props.droppableId}>
            {provided => (
                <div ref={provided.innerRef} {...provided.droppableProps} role='application'>
                    {props.children}
                    {provided.placeholder}
                </div>
            )}
        </Droppable>
    );
}

DroppableRegion.propTypes = {
    droppableId: PropTypes.string.isRequired
};

export default DroppableRegion;
